import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BusinessService } from '../../../../common/services/Business.service';
import { SettingService } from '../../../../common/services/Setting.service';
import { UploadService } from '../../../../common/services/Upload.service';
import { EvsAddressService } from '../../../../common/services/EvsAddress.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

declare var $: any;

@Component({
  selector: 'app-setting-view-product',
  templateUrl: 'setting-view-product.templete.html',
  styleUrls: ['./business.css'],
  providers: [BusinessService, EvsAddressService, UploadService, SettingService],
})
export class SettingViewProductComponent implements OnInit {
  public dataSettingProduct: any;
  public isCheck = 1;
  constructor(
    private _fb: FormBuilder,
    private settingService: SettingService,
    private toastr: ToastrService,
    private translate: TranslateService,
  ) {
  }
  ngOnInit() {
    this.getList();
  }

  getList() {
    this.settingService.getSettingViewProduct().subscribe((res: any) => {
      console.log('res', res)
      this.dataSettingProduct = res.data.items
      this.dataSettingProduct.map((res) => {
        if (res.description) {
          return res.description = res.description.replace('\\n', '<br>')
          console.log(res.description)
        }
      })
    }, (err: any) => {
      this.toastr.warning(this.translate.instant('CO_LOI_XAY_RA'), this.translate.instant('THAT_BAI'), {
        timeOut: 4000,
        positionClass: 'toast-top-right'
      })
    })
  }

  changeConfig(event, value: any) {
    const body = event.target.checked ? 1 : 0;
    const code = value.code
    this.settingService.updateSettingViewProduct(code, body).subscribe((res: any) => {
      this.toastr.success(this.translate.instant('THANH_CONG'), this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      })
    }, (err: any) => {
      this.toastr.warning(this.translate.instant('CO_LOI_XAY_RA'), this.translate.instant('THAT_BAI'), {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      })
    })
    console.log('event', event.target.checked)
    console.log('value', value)
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/business/setting-view-product.component.ts